/**
 * Display benefits of the free plan to users who are not logged in
 */
export const freePlanBenefits = {
  title: 'You ran out of 10 daily execution limits. Get more done with a free JDoodle account',
  points: [
    'All your projects under <strong>one account</strong>',
    '<strong>Share, invite</strong> and <strong>collaborate</strong> with other users',
    'Access to AI <strong>Assistant, Premium Embeds</strong> and <strong>much more.</strong>'
  ]
}

/**
 * Display benefits for users on the free plan to encourage upgrading
 */
export const proPlanBenefits = {
  title: 'You ran out of 100 per day execution limits. Upgrade and enjoy the following:',
  points: [
    '<strong>2X Faster</strong> workspace.',
    '<strong>20,000</strong> characters output limit',
    'Unlimited <strong>AI credits</strong>',
    'More <strong>collaborators per project</strong>'
  ]
}
/**
 * Display benefits for users on the free plan to encourage upgrading
 */
export const premiumPlanBenefits = {
  title: 'You ran out of 1000 per month execution limits. Upgrade and enjoy the following:',
  points: [
    '<strong>2X Faster</strong> workspace.',
    '<strong>20,000</strong> characters output limit',
    '<strong>Unlimited executions</strong> for account owners. Limited for other roles. See details',
    'Access to all <strong>language versions</strong> for account owners. Limited for other roles. See details',
    'Unlimited <strong>AI credits</strong>',
    'More <strong>collaborators per project</strong>'
  ]
}
